var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fortheowners',{attrs:{"case-studies":_vm.caseStudies,"white-paper":_vm.whitePaper,"seminar":_vm.seminar}}),_vm._v(" "),_c('BreadcrumbsFoot',{attrs:{"list":_vm.breadcrumbs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }